"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyBusinessLogicOnTableColumns = void 0;
const dictionary_1 = require("../TableCore/dictionary");
const typings_1 = require("../TableCore/typings");
const filterableColumnsMap = {
    [dictionary_1.tableDictionary.languages]: true,
    [dictionary_1.tableDictionary.version]: true,
    [dictionary_1.tableDictionary.fileType]: true,
    [dictionary_1.tableDictionary.type]: true,
    [dictionary_1.tableDictionary.validFor]: true,
    [dictionary_1.tableDictionary.status]: true,
};
const sortableColumnsMap = {
    [dictionary_1.tableDictionary.updated]: true,
    [dictionary_1.tableDictionary.expirationDate]: true,
};
const seachableColumnsMap = {
    [dictionary_1.tableDictionary.name]: true,
};
// Columns will be hidden if it is empty
const emptyColumnHideMap = {
    [dictionary_1.tableDictionary.validFor]: true,
    [dictionary_1.tableDictionary.approvalAuthority]: true,
    [dictionary_1.tableDictionary.expirationDate]: true,
};
const configulateColumnFilters = tableData => {
    return Object.assign(Object.assign({}, tableData), { columns: tableData.columns.map(column => {
            if ((tableData.tableType === typings_1.TableTypeEnum.Documents ||
                tableData.tableType === typings_1.TableTypeEnum.Approvals ||
                tableData.tableType === typings_1.TableTypeEnum.Drawings ||
                tableData.tableType === typings_1.TableTypeEnum.Software) &&
                filterableColumnsMap[column.name]) {
                return Object.assign(Object.assign({}, column), { filterable: true });
            }
            if (sortableColumnsMap[column.name]) {
                return Object.assign(Object.assign({}, column), { sortable: true });
            }
            if (seachableColumnsMap[column.name]) {
                return Object.assign(Object.assign({}, column), { searchable: true });
            }
            return column;
        }) });
};
const configulateHidingEmptyColumn = tableData => {
    return Object.assign(Object.assign({}, tableData), { columns: tableData.columns.filter(column => {
            if (emptyColumnHideMap[column.name]) {
                const isColumnEmpty = tableData.rows.every(row => {
                    return row[column] === '';
                });
                return isColumnEmpty ? null : column;
            }
            return column;
        }) });
};
const applyBusinessLogicOnTableColumns = tableData => {
    let data = tableData;
    data = configulateColumnFilters(data);
    return configulateHidingEmptyColumn(data);
};
exports.applyBusinessLogicOnTableColumns = applyBusinessLogicOnTableColumns;
